<template>
    <section class="section section-clients">
        <div class="container">
            <div class="row">
                <a class="target" aria-hidden="true" name="target" id="clients">&nbsp;</a>
                <h2 class="section-heading col-12">Clients</h2>
                <ul class="clients row col-12" :class="[allClientsVisible ? '' : 'clients-limit-height']">
                    <li v-for="client in clients" v-bind:key="client.id"
                        class="client col-6 col-sm-4 col-md-3 col-lg-2">
                        <a :href="client.url">
                            <img :src="client.logo" :alt="client.name">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container view-all-container">
            <div class="row">
                <div v-if="!allClientsVisible" class="view-all col-12">
                    <a role="button" href="#" v-on:click="viewAll">view all <i class="fa fa-arrow-down"></i></a>
                </div>
                <div v-if="allClientsVisible" class="view-less col-12">
                    <a role="button" href="#" v-on:click="viewLess">view less <i class="fa fa-arrow-up"></i></a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Clients",
    data() {
        return {
            allClientsVisible: false
        }
    },
    computed: {
        clients() {
            return this.allClientsVisible ? this.$store.getters.orderedCustomers : this.$store.getters.firstCustomers;
        }
    },
    methods: {
        viewAll: function (ev) {
            ev.preventDefault();

            this.allClientsVisible = true;
        },
        viewLess: function (ev) {
            ev.preventDefault();

            this.allClientsVisible = false;
            document.getElementById('clients').scrollIntoView();
        },
    }
}
</script>

<style scoped>
.section-clients .view-all-container a {
    color: #26828E;
}

.clients {
    list-style: none;
    margin-left: 0;
    margin-right: 0;

}

.clients.clients-limit-height {
    height: 10em;
    overflow: hidden;
}

.client {
    padding: 1.5em;
    text-align: center;
    height: 10em;
    line-height: 7em;
}

.client img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    margin: auto;
}

.client img:hover {
    /* filter: grayscale(100%); */
    opacity: 0.8;
}
</style>